import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const UpdatePluginCapabilitiesOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePluginCapabilitiesOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"capabilitiesOptions"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePlugin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fields"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"capabilitiesOptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"capabilitiesOptions"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"pluginId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"capabilitiesOptions"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"UpdatePluginCapabilitiesOptions","document":UpdatePluginCapabilitiesOptionsDocument}} as const;
export type UpdatePluginCapabilitiesOptionsMutationVariables = Types.Exact<{
  capabilitiesOptions?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  idPlugin: Types.Scalars['ID']['input'];
}>;


export type UpdatePluginCapabilitiesOptionsMutation = (
  { __typename: 'Mutation' }
  & { updatePlugin?: Types.Maybe<(
    { __typename: 'Plugin' }
    & Pick<Types.Plugin, 'id' | 'capabilitiesOptions'>
  )> }
);

export type UpdatePluginCapabilitiesOptionsMutationFn = Apollo.MutationFunction<
  UpdatePluginCapabilitiesOptionsMutation,
  UpdatePluginCapabilitiesOptionsMutationVariables
>;

/**
 * __useUpdatePluginCapabilitiesOptionsMutation__
 *
 * To run a mutation, you first call `useUpdatePluginCapabilitiesOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePluginCapabilitiesOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePluginCapabilitiesOptionsMutation, { data, loading, error }] = useUpdatePluginCapabilitiesOptionsMutation({
 *   variables: {
 *      capabilitiesOptions: // value for 'capabilitiesOptions'
 *      idPlugin: // value for 'idPlugin'
 *   },
 * });
 */
export function useUpdatePluginCapabilitiesOptionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePluginCapabilitiesOptionsMutation,
    UpdatePluginCapabilitiesOptionsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePluginCapabilitiesOptionsMutation,
    UpdatePluginCapabilitiesOptionsMutationVariables
  >(UpdatePluginCapabilitiesOptionsDocument, options);
}
export type UpdatePluginCapabilitiesOptionsMutationHookResult = ReturnType<
  typeof useUpdatePluginCapabilitiesOptionsMutation
>;
export type UpdatePluginCapabilitiesOptionsMutationResult =
  Apollo.MutationResult<UpdatePluginCapabilitiesOptionsMutation>;
export type UpdatePluginCapabilitiesOptionsMutationOptions =
  Apollo.BaseMutationOptions<
    UpdatePluginCapabilitiesOptionsMutation,
    UpdatePluginCapabilitiesOptionsMutationVariables
  >;
